import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Location } from '@angular/common';
import { SpinnerService } from '../../../shared';
import { PageNotAllowedActions, PageNotAllowedParams, PageNotAllowedState } from '../../../models';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'cmg-clear2-ui-page-not-allowed',
  templateUrl: './page-not-allowed.component.html',
  styleUrls: ['./page-not-allowed.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective],
})
export class PageNotAllowedComponent implements OnInit {
  private readonly _location = inject(Location);
  private readonly _spinnerService = inject(SpinnerService);

  params: PageNotAllowedParams;

  constructor() {
    const state = <PageNotAllowedState>this._location.getState();
    const routeParams = <PageNotAllowedParams>state?.params;

    this.params = routeParams
      ? routeParams
      : {
          title: 'Page Not Allowed',
          message: 'This page is not accessible for the current action.',
          buttonText: 'Return to Previous Page',
          buttonAction: PageNotAllowedActions.GoBack,
        };
  }

  ngOnInit(): void {
    this._spinnerService.reset();
  }

  action(): void {
    const buttonAction = this.params?.buttonAction;
    switch (buttonAction) {
      case PageNotAllowedActions.GoBack:
        history.back();
        break;
      case PageNotAllowedActions.ReturnToLoan:
        if (this.params?.fileDataId) {
          window.location.href = `${location.origin}/urla2/${this.params.fileDataId}`;
        } else {
          history.back();
        }
        break;
      case PageNotAllowedActions.GoToPipeline:
        window.location.href = `${location.origin}/pipeline`;
        break;
      default:
        history.back();
        break;
    }
  }
}
